import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute(
  "/_authenticated/account/saved-payment-methods"
)({
  loader: () => {
    return {
      crumb: { translationKey: "account.title" } as Crumb,
    }
  },
  component: Outlet,
})
